import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { QuoteToCartModel } from "@store/Types/QuoteToCart";

const quoteServiceUrl = "/api/v1/erp/quotes";

export interface GetQuoteToCartApiParameter extends ApiParameter {
    quoteId: string;
}

export function getQuoteToCartCollection(parameter: GetQuoteToCartApiParameter) {
    const { quoteId, ..._parameter } = parameter;

    return get<QuoteToCartModel>(`${quoteServiceUrl}/${quoteId}`, _parameter);
}
